/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DropInstagramPostResponse } from './DropInstagramPostResponse';
import {
    DropInstagramPostResponseFromJSON,
    DropInstagramPostResponseFromJSONTyped,
    DropInstagramPostResponseToJSON,
    DropInstagramPostResponseToJSONTyped,
} from './DropInstagramPostResponse';

/**
 * 
 * @export
 * @interface DropInstagramPostsResponse
 */
export interface DropInstagramPostsResponse {
    /**
     * 
     * @type {string}
     * @memberof DropInstagramPostsResponse
     */
    handle: string | null;
    /**
     * 
     * @type {Array<DropInstagramPostResponse>}
     * @memberof DropInstagramPostsResponse
     */
    posts: Array<DropInstagramPostResponse>;
    /**
     * 
     * @type {number}
     * @memberof DropInstagramPostsResponse
     */
    computedAt: number;
}

/**
 * Check if a given object implements the DropInstagramPostsResponse interface.
 */
export function instanceOfDropInstagramPostsResponse(value: object): value is DropInstagramPostsResponse {
    if (!('handle' in value) || value['handle'] === undefined) return false;
    if (!('posts' in value) || value['posts'] === undefined) return false;
    if (!('computedAt' in value) || value['computedAt'] === undefined) return false;
    return true;
}

export function DropInstagramPostsResponseFromJSON(json: any): DropInstagramPostsResponse {
    return DropInstagramPostsResponseFromJSONTyped(json, false);
}

export function DropInstagramPostsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropInstagramPostsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'handle': json['handle'],
        'posts': ((json['posts'] as Array<any>).map(DropInstagramPostResponseFromJSON)),
        'computedAt': json['computedAt'],
    };
}

export function DropInstagramPostsResponseToJSON(json: any): DropInstagramPostsResponse {
    return DropInstagramPostsResponseToJSONTyped(json, false);
}

export function DropInstagramPostsResponseToJSONTyped(value?: DropInstagramPostsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'handle': value['handle'],
        'posts': ((value['posts'] as Array<any>).map(DropInstagramPostResponseToJSON)),
        'computedAt': value['computedAt'],
    };
}

